import React from 'react'
class DisconnectionComponent extends React.Component {
  render () {
    return (
      <div style={styles.iconContent}
        onClick={this.props.onClick}>
        <img src={this.props.img} alt='true' style={styles.icon} />
        <span style={styles.disabledLabel}>{this.props.label}</span>
      </div>
    )
  }
}

const styles = {
  iconContent: {
    cursor: 'pointer',
    height: '80px',
    maxWidth: '56px'
  },
  icon: {
    marginTop: '10px',
    width: '32px',
    height: '36px',
    marginBottom: '-6px'
  },
  disabledLabel: {
    color: '#748591',
    marginLeft: '2px',
    fontSize: '9px',
    fontWeight: 'bold'
  }
}

export default DisconnectionComponent
